module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [(!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-left": "-10px"
    },
    domProps: {
      "innerHTML": _vm._s((_vm.Page.title))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.allContent)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-578b5fff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page.vue
// module id = 1260
// module chunks = 4